/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: 'ap-southeast-1',
  aws_appsync_graphqlEndpoint:
    'https://hvpgqvl4ynfxne5aabn3hrssau.appsync-api.ap-southeast-1.amazonaws.com/graphql',
  aws_appsync_region: 'ap-southeast-1',
  aws_appsync_authenticationType: 'API_KEY',
  aws_appsync_apiKey: 'da2-5mhpl4qsvzaurakvo5bhttigqa',
  aws_cognito_identity_pool_id: 'ap-southeast-1:bd427f62-8c8d-41e5-bb4c-19c89e180e3b',
  aws_cognito_region: 'ap-southeast-1',
  aws_user_pools_id: 'ap-southeast-1_gDxJFcXgQ',
  aws_user_pools_web_client_id: '34jbm8s09p75o1fd78bejuod9a',
  oauth: {
    domain: 'kmsamplifyefb091f0-efb091f0-dev.auth.ap-southeast-1.amazoncognito.com',
    scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: 'https://kms.ricarodo.com/,http://localhost:4200/',
    redirectSignOut: 'https://kms.ricarodo.com/,http://localhost:4200/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_user_files_s3_bucket: 'kmsamplify022b12c9f47c40abb46b400111dc6e75141556-dev',
  aws_user_files_s3_bucket_region: 'ap-southeast-1',
};

export default awsmobile;
